import { Injectable } from "@angular/core";

import { FA } from "./fragments/fragment-a";
import { FB } from "./fragments/fragment-b";
import { FC } from "./fragments/fragment-c";
import { FD } from "./fragments/fragment-d";

@Injectable()
export class KeyAssemblyService {
  private _key: string | null = null;

  private assembleKey(): string {
    const parts = [FA(), FB(), FC(), FD()];
    // The key is already exactly 32 bytes, no padding needed
    return parts.join("");
  }

  getKey(): string {
    if (!this._key) {
      this._key = this.assembleKey();
    }
    return this._key;
  }
}
